var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var CCN_MISSING = 'Credit card number is missing';
export var CCN_INVALID = 'This does not appear to be a valid credit card';
var MASK_CHARACTER = 'X';
var GAP_CHARACTER = '-';
export var sanitizeCreditCardNumber = function (ccNumber) {
    return ccNumber.replace(/\D+/g, '').trim();
};
export var isValidCCNLength = function (cardType, ccNumber) {
    var ccNumberLength = ccNumber.length;
    return (ccNumberLength !== 0 &&
        cardType.lengths.filter(function (len) { return ccNumberLength === len; }).length > 0);
};
export var validateCreditCardNumber = function (cardType, ccNumber) {
    var sanitizedCreditCardNumber = sanitizeCreditCardNumber(ccNumber);
    var ccNumberLength = sanitizedCreditCardNumber.length;
    if (ccNumberLength === 0) {
        return CCN_MISSING;
    }
    if (cardType.type === 'generic' ||
        !isValidCCNLength(cardType, sanitizedCreditCardNumber)) {
        return CCN_INVALID;
    }
    return undefined;
};
export var processCreditCardNumber = function (paymentCardType, ccNumber, showMasked) {
    var strippedPaymentInformation = sanitizeCreditCardNumber(ccNumber);
    var maskedCardNumber = strippedPaymentInformation;
    var cc = strippedPaymentInformation;
    if (paymentCardType && strippedPaymentInformation.length > 0) {
        var asterisks = MASK_CHARACTER.repeat(strippedPaymentInformation.length);
        var maskedCardDigits_1 = asterisks.split('');
        var cardDigits_1 = strippedPaymentInformation.split('');
        var gapsRightToLeft = __spreadArray([], paymentCardType.gaps, true).reverse();
        gapsRightToLeft === null || gapsRightToLeft === void 0 ? void 0 : gapsRightToLeft.forEach(function (gapIndex) {
            if (gapIndex < strippedPaymentInformation.length) {
                maskedCardDigits_1.splice(gapIndex, 0, GAP_CHARACTER);
                cardDigits_1.splice(gapIndex, 0, GAP_CHARACTER);
            }
        });
        maskedCardNumber = maskedCardDigits_1.join('');
        cc = cardDigits_1.join('');
    }
    return {
        maskedCardNumber: maskedCardNumber,
        cardNumber: strippedPaymentInformation,
        creditCardFieldValue: showMasked ? maskedCardNumber : cc,
        errorMessage: validateCreditCardNumber(paymentCardType, strippedPaymentInformation)
    };
};
